<template>
  <v-container fluid class="pa-0" style="background-color: white; height: inherit;">
    <v-progress-linear v-if="containerItemLoading" absolute indeterminate color="primary">
    </v-progress-linear>
    <v-progress-linear v-if="containerItemInitLoading" absolute indeterminate color="tertiary" class="mt-1">
    </v-progress-linear>
    <v-row no-gutters v-if="article" style="height: inherit;">
      <v-col :cols="isPhoneBool ? 12 : undefined">
        <EntityEditCard :title="$t('servicesystem.common_objects.commonterms.details')" :item="article"
          :saveMethod="saveChanges">
          <template v-slot:content="{ item, copy, editMode, handleFocus }">
            <ArticleEditContent :originalItem="copy" :editItem="item" :editMode="editMode" :handleFocus="handleFocus">
            </ArticleEditContent>
          </template>
        </EntityEditCard>
      </v-col>
      <template v-if="article.IsStoreArticle">
        <v-divider vertical style="z-index: 5;"></v-divider>
        <v-col :cols="isPhoneBool ? 12 : 5" style="background-color: rgba(0, 0, 0, 0.032);" class="pb-3">
          <h3 v-text="$t('servicesystem.common_objects.article.warehousing')" class="pa-3 pb-2 mb-2" />
          <template v-if="article.StoreItems && article.StoreItems.length > 0">
            <div class="d-flex align-center mr-4" style="margin-left: 38px;">
              <v-badge :color="'disabled'" inline dot class="mr-3"></v-badge>
              <span>{{ $t('servicesystem.common_objects.store.store') }}</span>
              <v-spacer></v-spacer>
              <span class="text--secondary">{{ $t('servicesystem.common_objects.store.available') }}</span>
            </div>
            <v-divider class="ml-3 mr-3 mt-1"></v-divider>
            <v-treeview :items="treeItems" :open="allOpen" item-key="id" open-on-click dense hoverable transition
              class="mr-2">
              <template v-slot:label="{ item, leaf }">
                <!-- store with children -->
                <div v-if="!leaf" class="d-flex align-center">
                  <StockDot :count="item.totalAvailable" class="mr-3" />
                  <span>
                    <v-icon size="18" class="mr-1">$store</v-icon>
                    {{ item.name }}
                  </span>
                  <v-spacer></v-spacer>
                  <span class="text--secondary">{{ item.totalAvailable }}</span>
                </div>

                <!-- leaf nodes -->
                <div v-else>
                  <!-- store with a single item -->
                  <div v-if="item.totalAvailable !== undefined" class="d-flex align-center"
                    style="width: 100%; gap: 12px;">
                    <StockDot :count="item.available" />
                    <span>
                      <v-icon size="18" class="mr-1">$store</v-icon>
                      {{ item.name }}
                      <span v-if="item.location && item.location != '-' && item.location != item.name" style="opacity: 0.8;">
                        / {{ item.location }}
                      </span>
                    </span>
                    <v-spacer></v-spacer>
                    <span class="text--secondary">{{ item.available }}</span>
                  </div>

                  <!-- normal child item -->
                  <div v-else class="d-flex justify-space-between align-center" style="width: 100%; gap: 12px;">
                    <span>
                      <StockDot :count="item.available" class="mr-1" />
                      <span style="opacity: 0.8;">{{ item.location }}</span>
                    </span>
                    <span class="text--secondary">{{ item.available }}</span>
                  </div>
                </div>
              </template>
            </v-treeview>
          </template>
          <template v-else>
            <v-list-item-subtitle class="pl-2" style="font-size: 13.5px !important;">
              <v-badge :color="'yellow'" inline dot></v-badge>
              Purchase order
            </v-list-item-subtitle>
          </template>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
//import StoreItem from "@/views/pim/articles/StoreItem.vue";
import EntityEditCard from '../../layouts/EntityEditCard.vue';
import ArticleEditContent from './ArticleEditContent.vue';
import StockDot from "./StockDot.vue";

export default {
  name: 'ViewArticleInfo',
  props: {
    containerItemInitLoading: Boolean, //getting container data for the first time, show skeletonloader
    containerItemLoading: Boolean, //loading container data update, do so in the background with small indicator
    containerItem: Object, //container data
  },
  components: {
    //StoreItem,
    StockDot,
    EntityEditCard,
    ArticleEditContent,
  },
  mixins: [clientAPI],

  data() {
    return {
      imageKey: 1,
    };
  },

  methods: {
    updateContainerData() {
      this.$emit('Refresh');
    },

    async saveChanges(obj) {
      var copy = Object.assign({}, obj);
      copy.timeStamp = undefined;
      copy.loading = undefined;
      copy.silentloading = undefined;
      const file = copy.newArticleImage;
      copy.newArticleImage = undefined;
      const dto = Object.assign({}, copy);
      await this.updateArticle(dto, file)
        .then((response) => {
          this.article = response;
        })
        .catch((exception) => {
          console.error(exception);
        });
    },

    groupBy(arr, key) {
      const initialValue = {};
      return arr.reduce((acc, cval) => {
        const myAttribute = cval[key];
        acc[myAttribute] = [...(acc[myAttribute] || []), cval]
        return acc;
      }, initialValue);
    },

    formatAvailable(val) {
      if (val == null) return 0;
      // if whole number, show as int, else round to 2 decimals
      return Number.isInteger(val) ? val : Number(val.toFixed(2));
    }
  },

  computed: {
    groupedByStore() {
      var all = (this.article && this.article.StoreItems) ? this.article.StoreItems : [];

      var storeMap = all.reduce((acc, si) => {
        var storeId = si.Store_Id != null ? si.Store_Id
          : si.StoreId != null ? si.StoreId
            : '__missing_store__';

        if (!acc[storeId]) {
          acc[storeId] = {
            storeId: storeId,
            storeName: si.StoreName || null,
            items: [],
            totalAvailable: 0
          };
        }
        acc[storeId].items.push(si);
        acc[storeId].totalAvailable += Number(si.Available || 0);
        return acc;
      }, {});

      var stores = Object.keys(storeMap).map(k => {
        var s = storeMap[k];
        s.items.sort((a, b) => {
          var an = (a.StoreLocationName || '');
          var bn = (b.StoreLocationName || '');
          if (!an && bn) return 1;
          if (an && !bn) return -1;
          var comp = an.localeCompare(bn);
          if (comp !== 0) return comp;
          return Number(b.Available || 0) - Number(a.Available || 0);
        });
        // format totalAvailable here
        s.totalAvailable = this.formatAvailable(s.totalAvailable);
        return s;
      });

      stores.sort((a, b) => (a.storeName || '').localeCompare(b.storeName || ''));
      return stores;
    },

    treeItems() {
      var t = this;
      return this.groupedByStore.map(function (s) {
        if (s.items.length === 1) {
          const si = s.items[0];
          return {
            id: 'store:' + s.storeId + ':single',
            name: s.storeName || '',
            totalAvailable: s.totalAvailable,
            location: si.StoreLocationName || '-',
            available: t.formatAvailable(si.Available)
          };
        } else {
          return {
            id: 'store:' + s.storeId,
            name: s.storeName || '',
            totalAvailable: s.totalAvailable,
            children: s.items.map(function (si, idx) {
              var locId = si.StoreLocation_Id != null ? si.StoreLocation_Id
                : si.StoreLocationId != null ? si.StoreLocationId
                  : 'no-loc';
              return {
                id: 'item:' + s.storeId + ':' + locId + ':' + idx,
                location: si.StoreLocationName || '-',
                available: t.formatAvailable(si.Available)
              };
            })
          };
        }
      });
    },

    allOpen() {
      return this.treeItems.map(function (n) { return n.id; });
    },

    article: {
      get() {
        //if we have a container item and no articleId in the route, put the id in the route
        if (this.containerItem && this.containerItem.Id && !this.$route.params.articleId) {
          this.$router.replace({
            name: this.$route.name,
            params: { ...this.$route.params, articleId: this.containerItem.Id },
            query: this.$route.query
          });
        }
        return this.containerItem;
      },
      set(value) {
        this.$emit('SetContainerItem', value);
      }
    },
  },

  watch: {
    editMode: function (newVal) {
      if (!newVal) {
        this.imageKey++;
      }
    },
  },
};
</script>


<style lang='scss' scoped>
.v-treeview-node__root {
  min-height: unset !important;
}
</style>